<main-content-holder>
  <div *ngIf="!roles || !roles.length" class="full-width full-height">
    <mat-spinner color="primary" diameter="40" class="loading-progress"></mat-spinner>
  </div>
  <div *ngIf="roles && roles.length > 0">
    <h2 class="center-align" i18n="Navigation|Select Role title@@navigation-select-role-title">Select Role</h2>

    <div fxLayout="column" class="full-width">
      <div class="center-align"
           i18n="Role Select|Role Select description@@role-select-description">Select role for current session
      </div>

      <form [formGroup]="roleSelectForm" class="center-align">
        <form-input [control]="roleField"
                    label="Role"
                    i18n-label="Sign Up|Sign Up role input label@@sign-up-role-input-label"
                    [options]="roles"
                    [compareWith]="compareRoles"
                    [displayWith]="displayRole"
                    (optionChanged)="selectRole($event)"></form-input>

        <div class="progress-spinner">
          <mat-spinner *ngIf="!roles" color="primary" class="center" [diameter]="40"></mat-spinner>
        </div>
      </form>

      <div class="footer center-align">
        <ng-container i18n="Sign In|Another account prompt@@sign-in-another-account-prompt">Want to use different
          account?
        </ng-container>
        <app-link class="sign-in-link"
                  label="Sign In"
                  i18n-label="Sign Up|Sign In URL label@@sign-up-sign-in-url-label"
                  (click)="signOut()"></app-link>
      </div>
    </div>

    <div class="language-switch">
      <language-switch theme="dark" [localeOverride]="true"></language-switch>
    </div>
  </div>
</main-content-holder>
